@if (!authService.authReady()) {
<app-global-loader></app-global-loader>
} @else {
<div> <app-header></app-header>
    <router-outlet />
    <p-toast position="bottom-center" />
    <app-uploading-toast />
</div>
}